registerComponent("sections/escritorios", function (component) {
/**
 * sections/escritorios — a entrada na rolagem (ADR 0051): o título, os rótulos
 * e os 33 escritórios entram escalonados quando a seção chega na tela (o
 * atraso tem teto de 1,3s, então a fila não se arrasta). O mapa não entra.
 *
 * @param {HTMLElement} component - elemento raiz do componente
 * @param {Object} params
 */

Asa.armarEntrada([component], '.entrada');

});
